module.exports = "<form>\r\n  <spk-card title=\"Search Queues\">\r\n    <spk-search-grid #grid list=\"QueueEntrySearchRow\" defaultSortProperty=\"QueueEntryId DESC\" [customFormats]=\"customFormats\"></spk-search-grid>\r\n  </spk-card>\r\n\r\n</form>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/queuing/queues/queues.component.html
// module id = ./src/app/components/framework/queuing/queues/queues.component.html
// module chunks = main